import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { between } from 'utils/number';
import { frozenTemperature, cooledTemperature } from 'utils/temperature';
import Icon from '@ontruck/ontruck-react-components/lib/Icon';
import style from './style.module.scss';
import { Tooltip } from '@ontruck/orc';
import TemperatureText from './TemperatureText';

const Icons = ({ min, max, intl, t, showTooltip = false }) => {
  const element = (
    <Fragment>
      {between(min, cooledTemperature) || between(max, cooledTemperature) ? (
        <Icon name="cold" className={style.extraIcon} />
      ) : null}
      {between(min, frozenTemperature) || between(max, frozenTemperature) ? (
        <Icon name="frozen" className={style.extraIcon} />
      ) : null}
    </Fragment>
  );

  if (!showTooltip) {
    return element;
  }

  return (
    <Tooltip
      component={<TemperatureText min={min} max={max} intl={intl} text={t.temperature} />}
      position="bottom"
      skin="light"
    >
      {element}
    </Tooltip>
  );
};

Icons.propTypes = {
  min: PropTypes.any,
  max: PropTypes.any,
  intl: PropTypes.any,
  t: PropTypes.any,
  showTooltip: PropTypes.bool,
};

export default Icons;
